import { Injectable, inject } from '@angular/core';

import { ConfigService } from '@rtms/client';

import { CookieName } from '../browser/cookie/cookie.models';
import { CookieService } from '../browser/cookie/cookie.service';
import { AppInfoConfig } from '../client-config/app-info.client-config';
import { PlatformProductMapConfig } from '../client-config/platform-product-map.client-config';
import { ProductService } from '../products/product.service';
import { ClaimType } from '../user/user.models';
import { UserService } from '../user/user.service';

@Injectable({
    providedIn: 'root',
})
export class RtmsConfigService implements ConfigService {
    private readonly appInfoConfig = inject(AppInfoConfig);
    private readonly userService = inject(UserService);
    private readonly cookieService = inject(CookieService);
    private readonly platformProductMapConfig = inject(PlatformProductMapConfig);
    private readonly productService = inject(ProductService);

    params(): any {
        const params: any = {
            brand: this.appInfoConfig.brand,
            frontend: this.appInfoConfig.frontend,
            product: this.platformProductMapConfig.isConfigReady
                ? (this.getMappedProduct() ?? this.appInfoConfig.product)
                : this.appInfoConfig.product,
            channel: this.appInfoConfig.channel,
            trackerId: this.cookieService.get(CookieName.TrackerId),
        };

        if (this.userService.isAuthenticated) {
            params.user = this.userService.id;
            params.sso = this.userService.ssoToken;
            params.country = this.userService.country;
            params.loyaltyCategory = this.userService.loyalty;
            params.tierCode = this.userService.claims.get(ClaimType.TierCode);
            params.vipLevel = this.userService.claims.get(ClaimType.VipLevel);
        }

        return params;
    }

    private getMappedProduct(): string | undefined {
        if (!this.productService.isSingleDomainApp) {
            return undefined;
        }

        const product = this.productService.current.name;
        const platformMap = this.platformProductMapConfig.platformProductMap;
        const defaultProd = this.productService.defaultProduct ?? 'host';
        return platformMap[product] ?? platformMap[defaultProd];
    }
}
